import { render } from "./manualOrdersForm.vue?vue&type=template&id=72a4cf50&scoped=true"
import script from "./manualOrdersForm.vue?vue&type=script&lang=js"
export * from "./manualOrdersForm.vue?vue&type=script&lang=js"

import "./manualOrdersForm.vue?vue&type=style&index=0&id=72a4cf50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a4cf50"]])

export default __exports__